import { Button } from "antd";
import styled from "style/themed";

export default styled(Button)`
  &&& {
    box-shadow: 0px 0px 20px -8px rgba(0, 0, 0, 0.75);
  }
`;
